import { IncentiveType, IncentiveStep } from 'interfaces';
import type { Component } from 'vue';
import BaseTemplate from '@/presentation/v2/BaseTemplate/BaseTemplate.vue';
import ScholarshipRegistrationHeader from '@/presentation/v2/Slots/ScholarshipUpdates/ScholarshipRegistrationHeader.vue';
import ScholarshipOptInContent from '@/presentation/v2/Slots/ScholarshipUpdates/ScholarshipOptInContent.vue';

export interface IncentiveDefinition {
	component: Component;
	steps: IncentiveStep[];
	slots?: {
		registrationHeader?: Component;
		optInContent?: Component;
	};
	dynamicSlots?: boolean;
}

export const incentive: Partial<Record<IncentiveType, IncentiveDefinition>> = {
	[IncentiveType.SCHOLARSHIP_UPDATES]: {
		component: BaseTemplate,
		steps: [IncentiveStep.REGISTRATION, IncentiveStep.LOGIN, IncentiveStep.OPT_IN, IncentiveStep.CPI],
		slots: {
			registrationHeader: ScholarshipRegistrationHeader,
			optInContent: ScholarshipOptInContent,
		},
	},

	[IncentiveType.EXPERIMENT]: {
		component: BaseTemplate,
		steps: [IncentiveStep.REGISTRATION, IncentiveStep.LOGIN, IncentiveStep.OPT_IN, IncentiveStep.CPI],
		dynamicSlots: true,
	},
};
